var cov_2faeienvgr = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Message/styles/index.js",
      hash = "bf25a8496a3b3907a8b2a0452027d57d2a31b767",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Message/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 28
        },
        end: {
          line: 7,
          column: 62
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

 // rely Alert


var messageLess = {};
import genaration from '../../utils/classname';
export var messageClass = (cov_2faeienvgr.s[0]++, genaration(messageLess, 'message'));